import { ReportExportProfileOptions } from 'app/modules/user/features/profile/types'
import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ExportProfileContextType {
  exportOptions: ReportExportProfileOptions | null
  setExportOptions: (options: ReportExportProfileOptions | null) => void
}

const ExportProfileContext = createContext<ExportProfileContextType | undefined>(undefined)

export const ExportProfileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [exportOptions, setExportOptions] = useState<ReportExportProfileOptions | null>(null)

  return (
    <ExportProfileContext.Provider value={{ exportOptions, setExportOptions }}>
      {children}
    </ExportProfileContext.Provider>
  )
}

export const useExportProfile = () => {
  const context = useContext(ExportProfileContext)
  if (!context) {
    throw new Error('useExportProfile must be used within ExportProfileProvider')
  }
  return context
}
